import { createContext } from "react";

const RoundContext = createContext();

export default RoundContext;
